import { GROUP_LIST } from '@/store/actions/group';

import groupApi from '@/api/group';

/* eslint-disable camelcase */


const state = {
  groups: []
};

const getters = {
  groupById: (state) => (id) => {
    return state.groups.find(g => g.group_id === id);
  }
};

const actions = {
  async [GROUP_LIST] ({ commit }) {
    commit(GROUP_LIST, await groupApi.getGroups());
  }
};

const mutations = {
  [GROUP_LIST] (state, groups) {
    state.groups = groups;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
